export function getToken() {
  return localStorage.getItem("token") || sessionStorage.getItem("token");
}

export function setToken(token, remember) {
  if (remember) {
    localStorage.setItem("token", token);
    sessionStorage.removeItem("token");
    return;
  }
  sessionStorage.setItem("token", token);
  localStorage.removeItem("token");
}

export function clearToken() {
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
}

export function redirectToLogin() {
  if (typeof window === "undefined") return;
  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
}

export function handleUnauthorizedResponse(response) {
  if (response?.status !== 401) {
    return false;
  }

  clearToken();
  redirectToLogin();
  return true;
}
